import { memo } from 'react';

import { FooterGeneralLinks } from './FooterGeneralLinks';

export * from './FooterGeneralLinks';

export default memo(FooterGeneralLinks);
